import React from 'react'
import Box from '@mui/material/Box'
import { useTheme, useMediaQuery } from '@mui/material'
import { bd2, bm1, bm2 } from '../../assets'

const Banner = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box>
        <Box
        sx={{
          position: "relative",
          color: "#fff",
          minHeight: { xs: "86vh", md: "100vh" },
          width: '100%',
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: { xs: 0, md: 0 },
          backgroundImage: {
            xs: `url(${bm2})`,
            md: `url(${bd2})`,
          },
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "cover",
        //   marginTop: { xs: "140px", md: 0 },
        }}
        />
    </Box>
  )
}

export default Banner